import { DisplayObject } from '@pixi/display';

DisplayObject.prototype.renderCanvas = function renderCanvas(_renderer) {
};
//# sourceMappingURL=DisplayObject.mjs.map
